import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Control } from "../Controls/Control";
import { ControlParams } from "../Controls/ControlInterfaces";

export class FakeComponent extends Control {
    public innerElement: HTMLInputElement;

    public static createControl(params: ControlParams): any {
        return new FakeComponent(params);
    }

    constructor(params: ControlParams) {
        super(params);

        this.innerElement = createElement({
            type: "input",
            attrs: {
                "type": "text",
                "disabled": "disabled",
            },
        }) as HTMLInputElement;

        this.element.appendChild(this.innerElement);
    }

    public set controlValue(value: any) {
        this.innerElement.value = value;
    }
}
